import { render } from "./Handicap.vue?vue&type=template&id=da36df20"
import script from "./Handicap.vue?vue&type=script&lang=js"
export * from "./Handicap.vue?vue&type=script&lang=js"

import "./Handicap.vue?vue&type=style&index=0&id=da36df20&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__